/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import Loader from "../../../Components/Common/Loader";
import TableHeader from "../../../Components/Common/TableHeader";
import CreditBalancesSearchForm from "../../../Components/Common/Statistics/CreditBalancesSearchForm";
import Pagination from "../../../Components/Common/Pagination";
import * as XLSX from "xlsx";


function PocketMoneyBalancesPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
        const [loading3, setLoading3] = useState(false);
    const [overallPocketMoneyBalance, setOverallPocketMoneyBalance] = useState(false);
    const [schoolPocketMoneyBalances, setSchoolPocketMoneyBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [meta, setMeta] = useState([]);
    const [pocketMoneyBalances, setPocketMoneyBalances] = useState([]);
    const [printablePocketMoneyBalances, setPrintablePocketMoneyBalances] = useState([]);

  useEffect(() => {
      if (query || school ) {
          searchPocketMoneyBalances();
      } else {
          getPocketMoneyBalances(page);
      }
  }, [page]);

  useEffect(() => {
        getOverallPocketMoneyBalance();
}, [page]);

useEffect(() => {
    getSchoolPocketMoneyBalances();
}, []);
useEffect(() => {
    printPocketMoneyBalances()
}, [query, school]);

  const getOverallPocketMoneyBalance = async () => {
      const server_response = await ajaxBank.fetchOverallPocketMoneyBalance();
      if (server_response.status === "OK") {
        setOverallPocketMoneyBalance(server_response.details);
      } else {
        setOverallPocketMoneyBalance("404");
      }
    };
  
  const getPocketMoneyBalances = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStudent.listAllPocketMoneyBalances(currentPage);
    setLoading(false);

    if (server_response.status === "OK") {
        setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setPocketMoneyBalances(server_response.details.data || []);
    } else {
        setPocketMoneyBalances([]);
    }
};

const searchPocketMoneyBalances = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllPocketMoneyBalances(page, school, query);
    setLoading2(false);
    if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setPocketMoneyBalances(server_response.details.data || []);
    } else {
        setPocketMoneyBalances([]);
    }
};

const printPocketMoneyBalances = async () => {
      setLoading(true);
      const server_response = await ajaxStudent.printAllStudentPocketMoneyBalances(query, school);
      setLoading(false);
      if (server_response.status === "OK") {
          setPrintablePocketMoneyBalances(server_response.details);
      } else {
          setPrintablePocketMoneyBalances([]);
      }
};

const getSchoolPocketMoneyBalances = async () => {
    setLoading3(true);
    const server_response = await ajaxBank.fetchAllSchoolPocketMoneyBalances();
    setLoading3(false);
    if (server_response.status === "OK") {
        setSchoolPocketMoneyBalances(server_response.details || []);  
    } else {
        setSchoolPocketMoneyBalances([]);
    }
};

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setPage(1);
    getPocketMoneyBalances(1);
    
  };

  const exportToPDF = () => {
      const pdf = new jsPDF("p", "pt", "a4");
      const columns = ["Student Name", "Buzz Number", "School Name", "Class", "Pocket Money"];
      const data = printablePocketMoneyBalances.map(item => [
        item.user,
        item.username,
        item.school,
        item.group,
        item.balance.total_c
      ]);
  
      pdf.autoTable({ head: [columns], body: data });
      pdf.save("pocket_money_balances_list.pdf");
    };

    const exportToExcel = () => {
          const worksheetData = printablePocketMoneyBalances.map((item) => ({
            "Student Name": item.user,
            "Buzz Number": item.username,
            "School Name": item.school,
            "Class": item.group,
            "Pocket Money": item.balance.total_c,
          }));
        
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Pocket Money Balances");
        
          XLSX.writeFile(workbook, "pocket_money_balances_list.xlsx");
    };


  return (
    <AppContainer title="Pocket Money Balances">
      <Toaster position="top-center" reverseOrder={false} />
        
       
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {overallPocketMoneyBalance? overallPocketMoneyBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Pocket Money Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-9 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Pocket Money Balances List"
          subtitle="List of all the students with their pocket money balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          {/* <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">...</a> */}
          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
        <Link class="" onClick={exportToExcel} role="button"><i class="fas fa-file-excel ml-3"></i></Link>
          
        </div>
      </div>

      <CreditBalancesSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery}
      searchCreditBalances={searchPocketMoneyBalances} setPage={setPage} resetSearch={setBalances} schoolList={schoolList}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Student Name</th>
                <th scope="col">Buzz Number</th>

                <th scope="col"> School</th>
                <th scope="col"> PM Balance</th>
                
                </tr>
            </thead>
            <tbody>
                {pocketMoneyBalances.length > 0 ? (
                    pocketMoneyBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/pocket-money-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        <td>{item.username}</td>

                        <td>{item.school}</td>
                        <td>UGX. {item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No students registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            <div class="col-lg-3 col-md-12 col-12 col-sm-12">
                            <div className="row">
                            {loading3 ? (
                                <Loader />
                                  ):(
                                    schoolPocketMoneyBalances.map((item, index) => (
                                        <div key={index} class="col-lg-12 col-md-12 col-12 col-sm-12">
                                            <div class="card custom-card">
                                                <div class="card-body">
                                                    <div>
                                                        <h6>{item.school_name}</h6>
                                                        <h6><span class="fs-30 me-2" style={{fontSize:"20px"}}>UGX. {item.balance?item.balance.total_c:"..."}</span></h6>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>)))}
                                       
                                
                                
                            </div>
                        </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default PocketMoneyBalancesPage;
